import React, { Component } from 'react';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class Confirm extends Component {
    static displayName = Confirm.name;

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleClick = this.handleClick.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    handleClick() {
        let modalID = this.props.id;
        var modalEl = document.getElementById(modalID);
        var thismodal = bootstrap.Modal.getInstance(modalEl);
       
        thismodal.hide();
        //모달이 여러개 뜨는경우가 있어 처리
        Big3Common.HistoryBackToClearBackdoor();
        if (this.props.ConfirmClick !== undefined) {
            this.props.ConfirmClick(modalID);
        }

    }

    render() {
        return (
            <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <div className={this.props.ClassName === undefined ? "icon icon-check" : this.props.ClassName}></div>

                            <div className="desc">
                                <div className="modal_title">{this.props.title}</div>
                                <div className="modal_txt" dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
                            </div>
                        </div>
                        <div className="modal-footer mf_v2">
                            <button type="button" className="btn2" data-bs-dismiss="modal">{this.props.FirstName === undefined ? "취소" : this.props.FirstName}</button>
                            <button type="button" className="btn2" data-bs-dismiss="modal" onClick={this.handleClick}>{this.props.SecondName === undefined ? "확인" : this.props.SecondName}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
